import React from "react";
import { AiOutlineExclamationCircle } from "react-icons/ai";

import Logo from "../assets/logo.png";

const Invoice = ({ customer, payments, totalAmount, paidAmount }) => {
  // Calculate summary of amounts
  const subTotal = paidAmount;
  const grandTotal = totalAmount - customer.discount - subTotal;

  let amount = 0;
  let services = "";

  if (customer.visa_fee) {
    amount += customer.visa_fee;
    services += `Visa Consultancy Fee (Rs ${customer.visa_fee})`;
  }
  if (customer.embassy_fee) {
    amount += customer.embassy_fee;
    services += ` | Embassy Fee (Rs ${customer.embassy_fee})`;
  }
  if (customer.appointment_fee) {
    amount += customer.appointment_fee;
    services += ` | Appointment Reservation Fee (Rs ${customer.appointment_fee})`;
  }
  if (customer.hotel_fee) {
    amount += customer.hotel_fee;
    services += ` | Hotel Booking Charges (Rs ${customer.hotel_fee})`;
  }
  if (customer.ticket_fee) {
    amount += customer.ticket_fee;
    services += ` | Ticket Fee (Rs ${customer.ticket_fee})`;
  }
  if (customer.insurance_fee) {
    amount += customer.insurance_fee;
    services += ` | Insurance Fee (Rs ${customer.insurance_fee})`;
  }

  if (customer.services) {
    customer.services.forEach((service) => {
      amount += parseInt(service.fee);
      services += ` | ${service.name}`;
    });
  }

  return (
    <div className="text-sm">
      <div className="grid grid-cols-2 justify-between gap-28 mb-4">
        <div className="space-y-1">
          <img src={Logo} width={100} className="invert m-4" />
          {/* <h2 className="text-xl font-bold">Jay Visa Consultancy</h2> */}
          <p>+92 321 3040505 | Info@jayvisa.com</p>
          <p className="capitalize">
            Able Plaza, near Khawaja Safdar Medical College, Sialkot, Punjab
            51310, Pakistan
          </p>
          <p className="text-gray-500 pt-2">
            Invoice Date: {new Date().toLocaleDateString()}
          </p>
        </div>
        <div className="space-y-1 uppercase">
          <h2 className="text-xl font-bold">{customer.name}</h2>
          <div className="font-semibold">Customer ID: {customer.id || "-"}</div>
          <p>{customer.phone}</p>
          <p>{customer.address}</p>
          <div className="font-semibold">
            Passport #: {customer.passport || "-"}
          </div>
          {willExpireInMonths(customer?.passport_expiry_at) && (
            <p className="text-red-600 text-xs flex items-center font-semibold capitalize">
              <AiOutlineExclamationCircle className="text-sm mr-1" />
              Passport Is About To Expire
            </p>
          )}
          <div className="pt-2 capitalize">
            Number of applicants:{" "}
            <strong>{(customer?.applicants?.length || 0) + 1}</strong>
          </div>
        </div>
      </div>

      {/* Services Aquired
      <ServicesAquired customer={customer} /> */}

      {/* Services Provided */}
      <div className="mb-4">
        <table className="w-full border-collapse border border-gray-300 capitalize">
          <thead>
            <tr className="bg-gray-100">
              <th className="border px-4 py-2 text-left w-2/3">Description</th>
              <th className="border px-4 py-2 text-left">Date</th>
              <th className="border px-4 py-2 text-right">Amount (PKR)</th>
            </tr>
          </thead>
          <tbody>
            {/* {!!customer.visa_fee && (
              <tr>
                <td className="border px-4 py-2">Visa Consultancy Fee</td>
                <td className="border px-4 py-2" />
                <td className="border px-4 py-2 text-right">
                  {customer.visa_fee}
                </td>
              </tr>
            )}
            {!!customer.embassy_fee && (
              <tr>
                <td className="border px-4 py-2">Embassy Fee</td>
                <td className="border px-4 py-2" />
                <td className="border px-4 py-2 text-right">
                  {customer.embassy_fee}
                </td>
              </tr>
            )}
            {!!customer.appointment_fee && (
              <tr>
                <td className="border px-4 py-2">
                  Appointment Reservation Fee
                </td>
                <td className="border px-4 py-2" />
                <td className="border px-4 py-2 text-right">
                  {customer.appointment_fee}
                </td>
              </tr>
            )}
            {!!customer.hotel_fee && (
              <tr>
                <td className="border px-4 py-2">Hotel Booking Charges</td>
                <td className="border px-4 py-2" />
                <td className="border px-4 py-2 text-right">
                  {customer.hotel_fee}
                </td>
              </tr>
            )}
            {!!customer.ticket_fee && (
              <tr>
                <td className="border px-4 py-2">Ticket Fee</td>
                <td className="border px-4 py-2" />
                <td className="border px-4 py-2 text-right">
                  {customer.ticket_fee}
                </td>
              </tr>
            )}
            {!!customer.insurance_fee && (
              <tr>
                <td className="border px-4 py-2">Insurance Fee</td>
                <td className="border px-4 py-2" />
                <td className="border px-4 py-2 text-right">
                  {customer.insurance_fee}
                </td>
              </tr>
            )}

            {customer?.services?.forEach((service) => {
              if (!service.fee) return;
              <tr>
                <td className="border px-4 py-2">{service.name}</td>
                <td className="border px-4 py-2" />
                <td className="border px-4 py-2 text-right">{service.fee}</td>
              </tr>;
              })} */}

            <tr>
              <td className="border px-4 py-2">{services}</td>
              <td className="border px-4 py-2" />
              <td className="border px-4 py-2 text-right font-bold">
                {amount}
              </td>
            </tr>

            {payments.map((payment) => (
              <tr>
                <td className="border px-4 py-2">{payment.description}</td>
                <td className="border px-4 py-2">
                  {new Date(payment.created_at).toLocaleDateString()}
                </td>
                <td className="border px-4 py-2 text-right">
                  {payment.amount.toLocaleString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="flex w-full">
        <div className="flex w-1/2 ml-auto">
          <table className="border-collapse border border-gray-300 w-full capitalize">
            <tbody>
              {/* <tr className="bg-gray-50">
              <td className="border p-4 py-3 font-semibold text-gray-500">
                Amount paid
              </td>
              <td className="border px-4 py-2 text-right">
                {paidAmount.toLocaleString()}
              </td>
            </tr> */}
              <tr className="bg-gray-50">
                <td className="border p-4 py-3 font-semibold text-gray-500">
                  Subtotal
                </td>
                <td className="border px-4 py-2 text-right">
                  {subTotal.toLocaleString()}
                </td>
              </tr>
              <tr className="bg-gray-50">
                <td className="border p-4 py-3 font-semibold text-gray-500">
                  Amount payable
                </td>
                <td className="border px-4 py-2 text-right">
                  {totalAmount.toLocaleString()}
                </td>
              </tr>
              {customer.discount && (
                <tr className="bg-gray-50">
                  <td className="border p-4 py-3 font-semibold text-gray-500">
                    Discount
                  </td>
                  <td className="border px-4 py-2 text-right">
                    {(customer.discount || 0).toLocaleString()}
                  </td>
                </tr>
              )}
              <tr className="bg-gray-50">
                <td className="border p-4 py-3 font-bold text-base">Balance</td>
                <td className="border px-4 py-2 text-right font-bold text-base">
                  {grandTotal.toLocaleString()} PKR
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="text-xs normal-case p-1 mt-5">
        <strong>Note:</strong>
        <ul className="space-y-1 mt-2">
          <li className="flex">
            <span className="mr-2">-</span> All payements are in advance.
          </li>
          <li className="flex">
            <span className="mr-2">-</span> In case of any visa refusal Or case
            withdrawal paid consultancy fee is non refundable.
          </li>
          <li className="flex">
            <span className="mr-2">-</span> We are not responsible for any
            change in appointment date for any embassy its totally
            depends upon embassy.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Invoice;

const ServicesAquired = ({ customer }) => {
  let amount = 0;
  let services = "";

  if (customer.visa_fee) {
    amount += customer.visa_fee;
    services += `Visa Consultancy Fee (Rs ${customer.visa_fee})`;
  }
  if (customer.embassy_fee) {
    amount += customer.embassy_fee;
    services += ` | Embassy Fee (Rs ${customer.embassy_fee})`;
  }
  if (customer.appointment_fee) {
    amount += customer.appointment_fee;
    services += ` | Appointment Reservation Fee (Rs ${customer.appointment_fee})`;
  }
  if (customer.hotel_fee) {
    amount += customer.hotel_fee;
    services += ` | Hotel Booking Charges (Rs ${customer.hotel_fee})`;
  }
  if (customer.ticket_fee) {
    amount += customer.ticket_fee;
    services += ` | Ticket Fee (Rs ${customer.ticket_fee})`;
  }
  if (customer.insurance_fee) {
    amount += customer.insurance_fee;
    services += ` | Insurance Fee (Rs ${customer.insurance_fee})`;
  }

  if (customer.services) {
    customer.services.forEach((service) => {
      amount += parseInt(service.fee);
      services += ` | ${service.name}`;
    });
  }

  return (
    <div className="mb-6">
      <table className="w-full border-collapse border border-gray-300 capitalize">
        <thead>
          <tr className="bg-gray-100">
            <th className="border px-4 py-2 text-left w-2/3">
              Services Acquired
            </th>
            <th className="border px-4 py-2 text-right">Total Amount (PKR)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="border px-4 py-2">{services}</td>
            <td className="border px-4 py-2 text-right">
              {amount.toLocaleString()}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

function willExpireInMonths(expiryDate) {
  if (!expiryDate) return;
  // Current date
  const currentDate = new Date();

  // Calculate the target date after '9'
  const targetDate = new Date();
  targetDate.setMonth(currentDate.getMonth() + 9);

  // Convert expiryDate to a Date object if it's a string
  const expiry = new Date(expiryDate);

  // Check if expiry date is within the target range
  return expiry <= targetDate && expiry >= currentDate;
}
